import ValidityHelper from '../../../Helpers/ValidityHelper';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import OpportunityPOCExportSearchParams from './OpportunityPOCExportSearchParams';
import contactService from '../../../Services/contactService';

export default class OpportunityPOCExportWindowDescription {
  static titleForCreate = 'Export Opportunity POC Report';
  static titleForEdit = 'Export Opportunity POC Report';
  static finishButtonLabel = 'Export';
  static itemType = OpportunityPOCExportSearchParams;
  static serviceFunction = (edited) => contactService.ExportOpportunityPOCList(edited);
  static waitForServiceFunction = () => false;
  static messageOnSuccess =
    'The Opportunity POC Report is being generated in the background. You will receive a notification when it is ready.';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'OfficeIds',
          label: 'Office',
          className: 'col-12',
          type: InputTypesEnum.OfficeOrGroupMultiSelect,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'ClientIsActive',
          label: 'Client Active',
          className: 'col-12',
          type: InputTypesEnum.EmptyYesNoSelect,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'StatusCodes',
          label: 'Opportunity Status',
          className: 'col-12',
          type: InputTypesEnum.LookupMultiChoice,
          selectvalues: 19,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'ModifiedOnFrom',
          label: 'Opportunity Last Modified Date From',
          className: 'col-6',
          type: InputTypesEnum.DateWithIndefinite,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'ModifiedOnTo',
          label: 'Opportunity Last Modified Date To',
          className: 'col-6',
          type: InputTypesEnum.DateWithIndefinite,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'ActualStartDateFrom',
          label: 'Actual Start Date From',
          className: 'col-6',
          type: InputTypesEnum.DateWithIndefinite,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'ActualEndDateUntil',
          label: 'Actual End Date Until',
          className: 'col-6',
          type: InputTypesEnum.DateWithIndefinite,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
      ],
    },
  ];
}
